import {checkIfAnyQuarter} from './checkIfAnyQuarter';

export const checkIfAdjacentToAnyQuarter = (hexKey, hexes, hexMath) => {
  const [q, r] = hexKey.split(',').map(Number);
  return hexMath.getNeighborsFlatTop(q, r).some(([nq, nr]) => checkIfAnyQuarter(hexes[`${nq},${nr}`]));
};
